import { InputHTMLAttributes } from "react";
import { useTheme } from "../hooks/useTheme";

interface InputCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {

}

export default function InputCheckbox (props: InputCheckboxProps) {

    const { theme } = useTheme();

    return (
        <input style={{ accentColor: theme.color.primary }} {...props} type="checkbox"/>
    );
}